import { render } from "./Showtz.vue?vue&type=template&id=61f7b406&scoped=true"
import script from "./Showtz.vue?vue&type=script&lang=js"
export * from "./Showtz.vue?vue&type=script&lang=js"

import "./Showtz.vue?vue&type=style&index=0&id=61f7b406&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f7b406"]])

export default __exports__